export function getTenantFromHostname(): string | null {
  const [sub] = window.location.hostname.split(".");
  return sub !== "risk-management" ? sub : null;
}

export function getBaseApiUrl(): string {
  const { protocol, hostname, port } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:8080";
  }

  const tenant = getTenantFromHostname();
  const domainParts = hostname.split(".");
  if (tenant) domainParts.shift();
  const baseDomain = domainParts.join(".");

  return tenant
    ? `${protocol}//${tenant}.${baseDomain}`
    : `${protocol}//${baseDomain}`;
}

export function getApiUrl(endpoint: string): string {
  const cleanEndpoint = endpoint.replace(/^\//, "");
  return `${getBaseApiUrl()}/${cleanEndpoint}`;
}

export function getTenantInfoUrl(): string {
  return getApiUrl("rest/public/tenants/info");
}

export function getEnviroment(): string {
  if (window.location.hostname.includes("localhost")) {
    return "local";
  }

  if (window.location.hostname.includes("qa")) {
    return "dev";
  }

  return "prod";
}
